export const PERSONALIZED_TIPS_ACTIONS = {
  FETCH_DATA: "FETCH_PERSONALIZED_TIPS_DATA",
  IMAGE_LOADED: "PERSONALIZED_TIPS_IMAGE_LOADED",
  IMAGES_TO_BE_LOADED: "PERSONALIZED_TIPS_IMAGES_TO_BE_LOADED",
};

export const onPersonalizedTipImageLoad = () => ({
  type: PERSONALIZED_TIPS_ACTIONS.IMAGE_LOADED
});

export const updatePersonalizedTipImagesToBeLoaded = (payload) => ({
  type: PERSONALIZED_TIPS_ACTIONS.IMAGES_TO_BE_LOADED,
  payload
});